import { Amazon, Button } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Amazon,
  Button,
  React
};